/**
 * @generated SignedSource<<b6e944ce99a21773eb3a249020c9915d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lang",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pictureURL",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfilePersonalInfoScreenQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfilePersonalInfoScreenQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f54acd8d60955dd60cd25ef9d27fa213",
    "id": null,
    "metadata": {},
    "name": "ProfilePersonalInfoScreenQuery",
    "operationKind": "query",
    "text": "query ProfilePersonalInfoScreenQuery {\n  user {\n    id\n    email\n    firstName\n    lastName\n    phoneNumber\n    lang\n    pictureURL\n  }\n}\n"
  }
};
})();

node.hash = "f6f6ce7a5a59bddc4a94f6488ed03320";

module.exports = node;
